import { Command } from 'commands/Commands';

export class Approve extends Command {
  type: string = 'Page.Approve';
  priority: number = 150;
}

export class Publish extends Command {
  type: string = 'Page.Publish';
  priority: number = 150;
}

export class Reject extends Command {
  type: string = 'Page.Reject';
  priority: number = 150;
}
